module.exports = __webpack_public_path__ + "static/img/show.25a145c4.png";